<mat-grid-list class="rate-plan" [cols]="(isDesktop) ? 6 : 1" gutterSize="0" rowHeight="5em" [ngClass]="{'desktop': isDesktop, 'mobile': !isDesktop}">
  <mat-grid-tile [colspan]="(isDesktop) ? 2 : 1" class="cell-product">
    <div class="cell">
      <p class="header">{{'rate_plan.product' | translate}}</p>
      <p class="data">{{ratePlan.productName}}</p>
    </div>
  </mat-grid-tile>
  <mat-grid-tile [colspan]="(isDesktop) ? 2 : 1" class="cell-plan">
    <div class="cell">
      <p class="header">{{'rate_plan.plan' | translate}}</p>
      <p class="data">{{ratePlan.ratePlanName}}</p>
    </div>
  </mat-grid-tile>
  <mat-grid-tile class="cell-charge">
    <div class="cell">
      <p class="header">{{'rate_plan.charge' | translate}}</p>
      <p class="data">{{chargeTranslationKeys[ratePlan.charge] | translate}}</p>
    </div>
  </mat-grid-tile>
  <mat-grid-tile class="cell-quantity">
    <div class="cell">
      <p class="header">{{'rate_plan.quantity' | translate}}</p>
      <p class="data">{{ratePlan.quantity}}</p>
    </div>
  </mat-grid-tile>
  <mat-grid-tile class="cell-start-date">
    <div class="cell">
      <p class="header">{{'rate_plan.start_date' | translate}}</p>
      <p class="data">{{ratePlan.startDate | date:'mediumDate':'':locale}}</p>
    </div>
  </mat-grid-tile>
  <mat-grid-tile class="cell-currency">
    <div class="cell">
      <p class="header">{{'rate_plan.currency' | translate}}</p>
      <p class="data">{{ratePlan.currency}}</p>
    </div>
  </mat-grid-tile>
  <mat-grid-tile class="cell-auto-renew">
    <div class="cell">
      <p class="header">{{'rate_plan.auto_renew' | translate}}</p>
      <mat-slide-toggle *ngIf="!isAutoRenewDisabled" color="primary" (mousedown)="handleToggleClick()" [formControl]="autoRenewControl">
      </mat-slide-toggle>
      {{((ratePlan.autoRenew) ? autoRenewKeys.Enabled : autoRenewKeys.Disabled) | translate}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile class="cell-auto-renew-date">
    <div class="cell">
      <p class="header">{{'rate_plan.auto_renewal_date' | translate}}</p>
      <p class="data">{{!ratePlan.renewalDate || isAutoRenewDisabled ? '—' : ratePlan.renewalDate | date:'mediumDate':'':locale}}</p>
    </div>
  </mat-grid-tile>
  <mat-grid-tile class="cell-next-charge-date">
    <div class="cell">
      <p class="header">{{'rate_plan.next_charge_date' | translate}}</p>
      <p class="data">{{(ratePlan.nextChargeDate | date:'mediumDate':'':locale) || '—'}}</p>
    </div>
  </mat-grid-tile>
  <mat-grid-tile class="cell-next-charge-amount">
    <div class="cell">
      <p class="header">{{'rate_plan.next_charge_amount' | translate}}</p>
      <p class="data">{{(ratePlan.nextChargeAmount | currency:ratePlan.currency:currencyDisplay) || '—'}}</p>
    </div>
  </mat-grid-tile>
</mat-grid-list>
